@if (active) {
<div>
  <ng-content></ng-content>
</div>
}
